<template>
	<div class="ui fluid container fc-checkout">
		<div class="ui container">
			<div class="fc-checkout-step">
				<div v-bind:class="{ 'fc-step1': true, 'fc-active': step == 1, 'fc-done': step > 1 }">
					<h4>
						<span v-if="step == 1">1-</span>
						<span v-if="step > 1" class="fc-check"></span>
						<span>Delivery Information</span>
						<a v-if="checkoutInfo.DeliveryType == 1" @click="step = 1">Edit</a>
					</h4>
					<p>We only deliver from <span>8am to 10pm</span>. Delivery charge will depend on the location and time.</p>
					<div class="fc-delivery-time" v-if="checkoutInfo.DeliveryType == 0">Pickup Time : <span>{{ checkoutInfo.DeliveryDateTime | dateToString('dd/M/yyyy hh:mm') }}</span></div>
					<div class="fc-delivery-time" v-if="checkoutInfo.DeliveryType == 1">Delivery Time : <span>{{ checkoutInfo.DeliveryDateTime | dateToString('dd/M/yyyy hh:mm') }}</span></div>
					<div class="fc-selected-outlet" v-if="checkoutInfo.DeliveryType == 0">
						<label>PICKUP OUTLET</label>
						<div>
							<span>{{ getSelectedOutlet(checkoutInfo.OutletId).Name }}</span>
							<span v-html="getSelectedOutlet(checkoutInfo.OutletId).OperatingHours"></span>
						</div>
					</div>
					<div class="fc-address-list" v-if="!addNewAddress && checkoutInfo.DeliveryType == 1">
						<span>DELIVER TO</span>
						<div v-for="item in addressList" v-bind:class="{ 'fc-address-item': true, 'fc-active': item.IsDefault}" @click.prevent="selectAddress(item)">
							<span>{{ item.FullName }}</span>
							<span>{{ item.MobileNo }}</span>
							<span>&nbsp;</span>
							<span>{{ item.PostalCode }}</span>
							<span>{{ item.UnitNo }}</span>
							<span>{{ item.Address }} {{ item.BuildingName }}</span>
							<span class="fc-change" @click="changeAddress(item)">Change</span>
							<a>&nbsp;</a>
						</div>
						<a @click="addNewAddress = true">Add new address</a>
						<div class="fc-continue">
							<a @click="checkStep(1)">CONTINUE</a>
						</div>
					</div>
					<div class="fc-newaddress" v-if="addNewAddress && checkoutInfo.DeliveryType == 1">
						<span>DELIVER TO</span>
						<div>
							<label><span>*</span>FULL NAME</label>
							<input type="text" v-model="newFullName" />
						</div>
						<div>
							<label><span>*</span>MOBILE NO.</label>
							<input type="text" v-model="newMobileNo" />
						</div>
						<div>
							<label><span>*</span>POSTCODE</label>
							<input @blur="getAddress" type="text" v-model="newPostalCode" />
						</div>
						<div>
							<label><span>*</span>UNIT NO.</label>
							<input type="text" v-model="newUnitNo" />
						</div>
						<div class="fc-address">
							<label>ADDRESS</label>
							<input type="text" v-model="newAddress" :placeholder="!findAddress ? 'Please fill in manually' : ''" />
						</div>
						<div class="fc-building-name">
							<label>BUILDING NAME</label>
							<input type="text" v-model="newBuildingName" />
              <a>Singapore ONLY</a>
						</div>
						<div class="fc-save">
							<input id="saveaddress" type="checkbox" value="true" v-model="newIsDefault" />
							<label for="saveaddress">Save address for future order</label>
						</div>
						<div class="fc-continue">
							<a @click="saveAddress">CONTINUE</a>
						</div>
					</div>
					<div class="fc-useraddress" v-if="selectedAddress != null && selectedAddress != undefined && checkoutInfo.DeliveryType == 1">
						<span>DELIVER TO</span>
						<span>{{ selectedAddress.FullName }}</span>
						<span>{{ selectedAddress.MobileNo }}</span>
						<span>&nbsp;</span>
						<span>{{ selectedAddress.Address }}</span>
						<span>{{ selectedAddress.UnitNo }}</span>
						<span>{{ selectedAddress.BuildingName }} {{ selectedAddress.PostalCode }}</span>
					</div>
				</div>
				<div v-bind:class="{ 'fc-step2': true, 'fc-active': step == 2, 'fc-done': step > 2 }">
					<h4>
						<span v-if="step <= 2">2-</span>
						<span v-if="step > 2" class="fc-check"></span>
						<span>Extra Promotion</span>
						<a @click="step = 2">Edit</a>
					</h4>
					<div class="fc-promotion-edit">
						<div>
							<label>CREDIT</label>
							<div>
								<input type="text" v-model="promotion.credit" />
								<label>Available credit : <span>${{ checkoutInfo.PointsBalance | price }}</span></label>
							</div>
						</div>
						<div style="display: none;">
							<label>VOUCHER</label>
							<div>
								<input type="text" v-model="promotion.voucher" placeholder="Voucher/promo code" />
								<a @click="applyVoucher">Apply</a>
							</div>
						</div>
						<a @click="checkStep(2)">CONTINUE</a>
					</div>
				</div>
				<div v-show="shouldPay" v-bind:class="{ 'fc-step3': true, 'fc-active': step == 3, 'fc-done': step > 3 }">
					<h4>
						<span v-if="step <= 3">3-</span>
						<span v-if="step > 3" class="fc-check"></span>
						<span>Payment</span>
						<a @click="step = 3">Edit</a>
					</h4>
					<div class="fc-payment-edit">
						<div>
							<label>CARD NUMBER</label>
							<card-number class='stripe-element card-number'
					      :stripe='paycard.stripe'
					      :options='numberOptions'
					      @change='numberChange($event)'
					    />
						</div>
						<div>
							<label>EXPIRATION DATE</label>
							<card-expiry class='stripe-element card-expiry'
					      :stripe='paycard.stripe'
					      @change='paycard.expiry = $event.complete'
					    />
						</div>
						<div>
							<label>CVV</label>
							<card-cvc class='stripe-element card-cvc'
					      :stripe='paycard.stripe'
					      @change='paycard.cvc = $event.complete'
					    />
						</div>
						<a @click="checkPayment">CONTINUE</a>
					</div>
					<div class="fc-payment-info" style="display: none;">
						<i class="icon-logo-visa"></i>
						<div>CARD ENDING WITH <span>7890</span></div>
					</div>
				</div>
			</div>
			<div class="fc-order-price-detail">
				<div class="fc-order-summary">
					<div>
						<span>ORDER SUMMARY</span>
					</div>
					<div class="fc-subtotal">
						<div>Subtotal</div>
						<span>${{ checkoutInfo.SubTotalPrice | price }}</span>
					</div>
					<div class="fc-discount" v-if="discount.code != '' || discount.price > 0">
						<div>Discount <a>{{ discount.code }} <span @click="clearDiscount">&nbsp;</span></a></div>
						<span>-${{ discount.price | price }}</span>
					</div>
					<div class="fc-delivery" v-if="checkoutInfo.DeliveryFee > 0">
						<div>Delivery fee</div>
						<span>${{ checkoutInfo.DeliveryFee | price }}</span>
					</div>
          <div class="fc-discount" v-if="promotion.credit > 0">
            <div>Credit</div>
            <span>-${{ promotion.credit | price }}</span>
          </div>
					<div class="fc-total">
						<div>TOTAL</div>
						<span>${{ orderPrice | price }}</span>
					</div>
					<div class="fc-control">
						<a :disabled="step < 4" @click="checkDeliveryDate">
							COMPLETE ORDER
						</a>
					</div>
					<div class="fc-payment-methods">
						<i class="icon-img-trustbadge">&nbsp;</i>
					</div>
				</div>
				<div class="fc-earn-info">
					<i class="icon-ico-earn"></i>
					<div>
						This order will earn you : <span>${{ checkoutInfo.WillEarnPoints | price }}</span> for your future purchase 
					</div>
				</div>
			</div>
		</div>
		<checkout-edit-address v-if="editingAddress != null" v-on:close="editingAddress = null" :editAddress="editingAddress" />
	</div>
</template>
<script>
import moment from 'moment'
import { mapGetters, mapActions } from 'vuex'
import { mapFields, mapMultiRowFields } from 'vuex-map-fields'
import EditAddress from '../../components/checkout/EditAddress'
import $ from 'jquery'
import { CardNumber, CardExpiry, CardCvc, createToken } from 'vue-stripe-elements-plus'
export default {
  data () {
    return {
      step: 1,
      shouldPay: true,
      findAddress: true,
      addNewAddress: false,
      isAddressDefauled: false,
      selectedOutletId: 0,
      promotion: {
        credit: 0,
        voucher: ''
      },
      discount: {
        code: '',
        price: 0
      },
      editingAddress: null,
      paycard: {
        // stripe: 'pk_test_JmbX9WTz3QRBvNpDBxnZFQ89',
        stripe: 'pk_live_msLlSkv8vTHEGGSCiRPpJVxO00rc7cz4Vt',
        number: false,
        expiry: false,
        cvc: false
      },
      numberOptions: {
        base: {
          fontSize: '14px'
        },
        placeholder: '**** **** **** ****'
      }
    }
  },
  components: {
    'checkout-edit-address': EditAddress, CardNumber, CardExpiry, CardCvc
  },
  created () {
    const orderId = this.$route.query.id
    if (orderId !== null && orderId !== undefined && orderId > 0) {
      this.$store.dispatch('cart/cartPreAdd')
      this.$store.dispatch('order/getCheckoutInfo', orderId)
      this.$store.dispatch('customer/getAddressList')
    }
  },
  methods: {
    ...mapActions('customer', ['selectAddress']),
    getSelectedOutlet (id) {
      return this.preAdd.Outlets.filter(a => a.OutletId === id)[0]
    },
    saveAddress () {
      const pc = this.newPostalCode
      if (pc === '' || pc.length !== 6 || isNaN(parseInt(pc)) || parseInt(pc) < 10) {
        if (process.browser) {
          $.alert({
            title: 'Notice',
            content: 'Invalid postal code',
            type: 'red',
            useBootstrap: false
          })
        }
        return
      }
      this.$store.dispatch('customer/addAddress')
        .then(() => {
          this.addNewAddress = false
          this.checkStep(1)
        })
    },
    getAddress: function () {
      const pc = this.newPostalCode
      if (pc === '' || pc.length !== 6 || isNaN(parseInt(pc)) || parseInt(pc) < 10) {
        if (process.browser) {
          $.alert({
            title: 'Notice',
            content: 'Invalid postal code',
            type: 'red',
            useBootstrap: false
          })
        }
        return
      }
      this.$store.dispatch('address/getAddress', this.newPostalCode)
        .then(a => {
          if (a !== null) {
            this.findAddress = true
            this.newAddress = a.BLK_NO + ' ' + a.ROAD_NAME + ' ' + a.BUILDING
          } else {
            this.findAddress = false
            this.newAddress = ''
          }
        })
    },
    changeAddress: function (address) {
      this.editingAddress = {
        Address: address.Address,
        BuildingName: address.BuildingName,
        CustomersAddressId: address.CustomersAddressId,
        FullName: address.FullName,
        IsDefault: address.IsDefault,
        MobileNo: address.MobileNo,
        PostalCode: address.PostalCode,
        UnitNo: address.UnitNo
      }
    },
    checkOutlet (o) {
      const deliveryDate = new Date(this.checkoutInfo.DeliveryDateTime.replace(/-/g, '/').replace('T', ' '))
      var timeFrom = ''
      var timeEnd = ''
      if (deliveryDate.getDay() === 0) {
        timeFrom = o.OperatingHoursSunFrom
        timeEnd = o.OperatingHoursSunEnd
      } else if (deliveryDate.getDay() === 1) {
        timeFrom = o.OperatingHoursMonFrom
        timeEnd = o.OperatingHoursMonEnd
      } else if (deliveryDate.getDay() === 2) {
        timeFrom = o.OperatingHoursTuesFrom
        timeEnd = o.OperatingHoursTuesEnd
      } else if (deliveryDate.getDay() === 3) {
        timeFrom = o.OperatingHoursWedFrom
        timeEnd = o.OperatingHoursWedEnd
      } else if (deliveryDate.getDay() === 4) {
        timeFrom = o.OperatingHoursThurFrom
        timeEnd = o.OperatingHoursThurEnd
      } else if (deliveryDate.getDay() === 5) {
        timeFrom = o.OperatingHoursFriFrom
        timeEnd = o.OperatingHoursFriEnd
      } else if (deliveryDate.getDay() === 6) {
        timeFrom = o.OperatingHoursSatFrom
        timeEnd = o.OperatingHoursSatEnd
      }
      const selectMonth = deliveryDate.getMonth() < 10 ? ('0' + (deliveryDate.getMonth() + 1).toString()) : (deliveryDate.getMonth() + 1).toString()
      const selectDay = deliveryDate.getDate() < 10 ? ('0' + (deliveryDate.getDate()).toString()) : (deliveryDate.getDate()).toString()
      const selectDate = deliveryDate.getFullYear() + '/' + selectMonth + '/' + selectDay
      const dateFrom = new Date(selectDate + ' ' + timeFrom + ':00')
      const dateEnd = new Date(selectDate + ' ' + timeEnd + ':00')
      if (deliveryDate.getTime() < (dateFrom.getTime() + (2 * 60 * 60 * 1000)) || deliveryDate.getTime() > dateEnd.getTime()) {
        return false
      } else {
        return true
      }
    },
    checkStep: function (step) {
      if (step === 1) {
        if (this.selectedAddress === null || this.selectedAddress.CustomersAddressId === undefined || this.selectedAddress.CustomersAddressId <= 0) {
          if (process.browser) {
            $.alert({
              title: 'Notice',
              content: 'Please select your delivery address',
              type: 'orange',
              useBootstrap: false
            })
          }
          return
        }

        if (this.selectedAddress.PostalCode.toString().length !== 6) {
          $.alert({
            title: 'Notice',
            content: 'Invalid postal code',
            type: 'red',
            useBootstrap: false
          })
          return
        }
        const preCode = this.selectedAddress.PostalCode.toString().substring(0, 2)
        if (this.preAdd.NoDeliveryLocations != null && this.preAdd.NoDeliveryLocations.indexOf(preCode) >= 0) {
          if (process.browser) {
            $.alert({
              title: 'Notice',
              content: 'Sorry, this postal code is not in our delivery locations',
              type: 'red',
              useBootstrap: false
            })
          }
          return
        }
        const o = this.preAdd.Outlets.filter(a => a.DeliveryPostalZones.indexOf(preCode) >= 0)
        if (o.length > 0) {
          this.selectedOutletId = o[0].OutletId
          if (!this.checkOutlet(o[0])) {
            const tmpO = this.preAdd.Outlets.filter(a => a.OutletId === o[0].ReplacementOutletId)
            this.selectedOutletId = tmpO[0].OutletId
            if (tmpO.length > 0) {
              if (!this.checkOutlet(tmpO[0])) {
                if (process.browser) {
                  $.alert({
                    title: 'Notice',
                    content: 'Sorry, we are unable to handle orders at the selected time.',
                    type: 'red',
                    useBootstrap: false
                  })
                }
                return
              }
            } else {
              if (process.browser) {
                $.alert({
                  title: 'Notice',
                  content: 'Sorry, we are unable to handle orders at the selected time.',
                  type: 'red',
                  useBootstrap: false
                })
              }
              return
            }
          }
        } else {
          if (process.browser) {
            $.alert({
              title: 'Notice',
              content: 'There is no outlet for your postal code',
              type: 'red',
              useBootstrap: false
            })
          }
          return
        }

        this.step = 2
      } else if (step === 2) {
        const theCredit = parseFloat(this.promotion.credit)
        if (isNaN(theCredit)) {
          if (process.browser) {
            $.alert({
              title: 'Notice',
              content: 'Invalid credit',
              type: 'orange',
              useBootstrap: false
            })
          }
          return
        }
        if (theCredit > parseFloat(this.checkoutInfo.PointsBalance)) {
          if (process.browser) {
            $.alert({
              title: 'Notice',
              content: 'Have no enough credits',
              type: 'orange',
              useBootstrap: false
            })
          }
        } else if (theCredit > parseFloat(this.checkoutInfo.TotalPrice)) {
          if (process.browser) {
            $.alert({
              title: 'Notice',
              content: 'Credits should less than total prive',
              type: 'orange',
              useBootstrap: false
            })
          }
        } else if (theCredit === parseFloat(this.checkoutInfo.TotalPrice)) {
          this.step = 4
          this.shouldPay = false
        } else {
          this.step = 3
          this.shouldPay = true
        }
      }
    },
    applyVoucher () {
      if (this.promotion.voucher === null || this.promotion.voucher === '') {
        if (process.browser) {
          $.alert({
            title: 'Notice',
            content: 'Please input your voucher code',
            type: 'orange',
            useBootstrap: false
          })
        }
        return
      }
      const voucherData = {
        OrderId: parseInt(this.$route.query.id),
        VoucherCode: this.promotion.voucher
      }
      this.$store.dispatch('order/applyVoucher', voucherData)
        .then(res => {
          this.discount.code = this.promotion.voucher
          if (res.DiscountType === 1) {
            this.discount.price = res.AmountDiscount
          } else if (res.DiscountType === 2) {
            this.discount.price = this.checkoutInfo.TotalPrice * res.PercentageDiscount
          }
        })
    },
    clearDiscount () {
      this.promotion.voucher = ''
      this.discount = {
        code: '',
        price: 0
      }
    },
    numberChange (e) {
      this.paycard.number = e.complete
    },
    checkPayment () {
      if (!this.paycard.number || !this.paycard.expiry || !this.paycard.cvc) {
        if (process.browser) {
          $.alert({
            title: 'Notice',
            content: 'Please input your payment cart info',
            type: 'orange',
            useBootstrap: false
          })
        }
      } else {
        this.step = 4
      }
    },
    checkDeliveryDate () {
      if (process.browser) {
        const deliverydate = moment(this.checkoutInfo.DeliveryDateTime)
        const nearTime = moment().add(2, 'hours')
        const dtype = this.checkoutInfo.DeliveryType === 0 ? 'self collection' : 'delivery'
        const _this = this
        if (nearTime.isAfter(deliverydate)) {
          $.confirm({
            title: 'Dear Customer',
            content: '<div style="color:#666;">We will need 2 hours to prepare your order and arrange for delivery.<br />System had auto adjusted your ' + dtype + ' timing to ' + nearTime.format('HH:mm') + ' on ' + nearTime.format('DD/MMM/YYYY') + '<br /><br />Should you had any query, feel free to contact us at <a style="color:#009938;" href="mailto:onlineorder@sub2u.com">onlineorder@sub2u.com</a> or 8168 5918.</div>',
            buttons: {
              confirm: function () {
                _this.updateDeliveryTime()
              },
              cancel: function () {}
            },
            type: 'red',
            useBootstrap: false
          })
        } else {
          this.createPaymentToken()
        }
      }
    },
    updateDeliveryTime () {
      this.$store.dispatch('order/changeDeliveryDate', { OrderId: this.$route.query.id })
        .then(() => {
          this.createPaymentToken()
        })
    },
    createPaymentToken () {
      if (process.browser) {
        $('.fc-loading').show()
        if (!this.shouldPay) {
          this.completeOrder('')
        } else {
          createToken()
            .then(data => {
              if (data.token === null || data.token === undefined) {
                $.alert({
                  title: 'Error',
                  content: data.error.message,
                  type: 'red',
                  useBootstrap: false
                })
              } else {
                const tokenId = data.token.id
                this.completeOrder(tokenId)
              }
              $('.fc-loading').hide()
            })
            .catch((a) => {
              $.alert({
                title: 'Error',
                content: 'Payent fail',
                type: 'red',
                useBootstrap: false
              })
              $('.fc-loading').hide()
            })
        }
      }
    },
    completeOrder (tokenId) {
      const data = {
        OrderId: parseInt(this.$route.query.id),
        CustomersAddressId: this.selectedAddress.CustomersAddressId,
        UsePoints: parseFloat(this.promotion.credit),
        VoucherCode: this.promotion.voucher,
        StripeSourceId: tokenId,
        OutletId: this.selectedOutletId
      }
      this.$store.dispatch('order/complete', data)
        .then(a => {
          this.$router.push({path: this.RouterConfig.CheckoutSuccess, query: {id: a.OrderId}})
        })
    }
  },
  computed: {
    ...mapFields('customer', {
      newFullName: 'newAddress.FullName',
      newMobileNo: 'newAddress.MobileNo',
      newPostalCode: 'newAddress.PostalCode',
      newUnitNo: 'newAddress.UnitNo',
      newAddress: 'newAddress.Address',
      newBuildingName: 'newAddress.BuildingName',
      newIsDefault: 'newAddress.IsDefault',
      selectedAddress: 'selectedAddress'
    }),
    ...mapMultiRowFields('customer', {
      addressList: 'addressList'
    }),
    ...mapGetters('address', ['address']),
    ...mapFields('order', {
      checkoutInfo: 'checkoutInfo'
    }),
    ...mapFields('cart', ['preAdd']),
    orderPrice () {
      var theCredit = 0
      if (!isNaN(this.promotion.credit)) {
        theCredit = this.promotion.credit
      }
      return this.checkoutInfo.TotalPrice - theCredit >= 0 ? (this.checkoutInfo.TotalPrice - theCredit) : 0
    }
  },
  watch: {
    addressList () {
      if (this.checkoutInfo !== null && this.checkoutInfo.DeliveryPostalCode !== undefined && this.checkoutInfo.DeliveryPostalCode !== '') {
        if (this.checkoutInfo.DeliveryType === 1) {
          for (var i = 0; i < this.addressList.length; i++) {
            this.addressList[i].IsDefault = this.addressList[i].PostalCode === this.checkoutInfo.DeliveryPostalCode
            if (this.addressList[i].IsDefault) {
              this.selectAddress(this.addressList[i])
            }
          }
          if (this.addressList.filter(a => a.IsDefault).length < 1) {
            this.addNewAddress = true
          }
        }
      }
    },
    checkoutInfo () {
      this.selectedOutletId = this.checkoutInfo.OutletId
      if (this.checkoutInfo.DeliveryType === 0) {
        this.step = 2
      } else {
        if (this.addressList !== null && this.addressList.length > 0) {
          for (var i = 0; i < this.addressList.length; i++) {
            this.addressList[i].IsDefault = this.addressList[i].PostalCode === this.checkoutInfo.DeliveryPostalCode
            if (this.addressList[i].IsDefault) {
              this.selectAddress(this.addressList[i])
            }
          }
          if (this.addressList.filter(a => a.IsDefault).length < 1) {
            this.addNewAddress = true
          }
        }
        this.newPostalCode = this.checkoutInfo.DeliveryPostalCode.replace(/\s/g, '')
        if (this.newPostalCode !== null && this.newPostalCode !== undefined && this.newPostalCode !== '' && this.newPostalCode.length > 4) {
          this.getAddress()
        }
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/checkout/Checkout.vue